"use strict";
/**
 * @description 斜体
 * @author liuwei
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BtnMenu_1 = __importDefault(require("../menu-constructors/BtnMenu"));
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var Italic = /** @class */ (function (_super) {
    __extends(Italic, _super);
    function Italic(editor) {
        var _this = this;
        var $elem = dom_core_1.default("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-italic\"></i>\n            </div>");
        _this = _super.call(this, $elem, editor) || this;
        return _this;
    }
    /**
     * 点击事件
     */
    Italic.prototype.clickHandler = function () {
        var editor = this.editor;
        var isSelectEmpty = editor.selection.isSelectionEmpty();
        if (isSelectEmpty) {
            // 选区范围是空的，插入并选中一个“空白”
            editor.selection.createEmptyRange();
        }
        // 执行 italic 命令
        editor.cmd.do('italic');
        if (isSelectEmpty) {
            // 需要将选区范围折叠起来
            editor.selection.collapseRange();
            editor.selection.restoreSelection();
        }
    };
    /**
     * 尝试修改菜单激活状态
     */
    Italic.prototype.tryChangeActive = function () {
        var editor = this.editor;
        if (editor.cmd.queryCommandState('italic')) {
            this.active();
        }
        else {
            this.unActive();
        }
    };
    return Italic;
}(BtnMenu_1.default));
exports.default = Italic;
